import React, { useCallback, useContext } from "react";

import { Site } from "../../../../../dtos/site";
import { RequestState } from "../../../../../enums/requestState";
import SignalRContext from "../../../../../signalr/context";
import { ButtonWithConfirm } from "../../../../ButtonWithConfirm";
import { useApi } from "../../../../useApi";

import { actionButtonStyle } from "./actionButtonStyle";
import { useRestartAction } from "./useRestartAction";

const buttonLabels: { [key in RequestState]: string; } = {
    [RequestState.Idle]: "Restart",
    [RequestState.Requesting]: "Requesting...",
    [RequestState.Processing]: "Restarting HMI device...",
}

interface Props {
    site: Site;
}

export function RestartHmiDeviceButton({ site }: Props) {
    const { siteApi } = useApi();
    const { restartHmiDeviceCompleted } = useContext(SignalRContext);

    const request = useCallback(() => siteApi.restartHmiDevice(site.id), [siteApi, site.id]);

    const { requestState, trigger } = useRestartAction({
        siteId: site.id,
        request,
        ack: restartHmiDeviceCompleted,
        requestErrorMessage: "ERROR: Failed to request HMI device restart",
        // The site acks once the reboot command reaches the tablet, not once it has rebooted.
        successMessage: "Restart command sent to HMI device",
        failureMessage: "ERROR: HMI device is not configured for this site",
    });

    return (
        <ButtonWithConfirm
            confirmDialogContent="Are you sure you want to restart the HMI device?"
            confirmedCallback={trigger}
            disabled={requestState !== RequestState.Idle}
            style={actionButtonStyle}
        >
            {buttonLabels[requestState]}
        </ButtonWithConfirm>
    );
}
